import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    transformHttpResponse,
} from 'utils';
import { fetchAttendance } from './listAction';

/**
 * "Mark Selected National Team" / "Remove Selected National Team Mark" /
 * "Mark All National Team" / "Remove All National Team Mark" — one generic
 * action, mirrors bulkUpdateAttendance's shape. `sportsmanIds: null` means
 * every athlete registered for the competition.
 *
 * Unlike bulkUpdateAttendance, this does NOT dispatch anything marking
 * CompetitionResult rows stale — National Team classification never drives
 * a bracket/draw side effect (see api/docs/ATTENDANCE.md), so there is
 * nothing for the results store to learn about.
 */
export const bulkUpdateNationalTeamMember = (competitionId, isNationalTeamMember, sportsmanIds) => {
    return function(dispatch) {
        const options = apiRequestOptions(
            apiPath.ATTENDANCE.NATIONAL_TEAM_BULK,
            { isNationalTeamMember, sportsmanIds },
            { params: { competition: competitionId } }
        );

        return axios(options)
            .then(transformHttpResponse)
            .then(response => dispatch(fetchAttendance(competitionId)).then(() => response.data))
            .catch(rejectWithViolationMessage);
    }
};

const rejectWithViolationMessage = error => {
    const violations = error.response && error.response.data && error.response.data.violations;
    const message = (violations && violations.length && violations[0].message)
        || (error.response && error.response.data && error.response.data['hydra:description'])
        || (error.response && error.response.data && error.response.data.message)
        || 'Save failed';
    return Promise.reject(new Error(message));
};
